import React from 'react';
import PropTypes from 'prop-types';
import WizardInput from '../Input';
import Input from '../../Input';
import styles from './styles.less';

const SchoolName = ({ t, schoolTitle, setValue }) => (
  <>
    <WizardInput title={t('course.create.wizard.step5_1')} hint={t('wizard.hint.school')}>
      <Input
        version="long"
        size="large"
        value={schoolTitle}
        onChange={e => setValue(e.target.value, 'schoolTitle')}
        placeholder={t('course.create.wizard.mail.schoolname.text')}
        className={styles.schoolName}
        name="wizard_input_school_name"
      />
    </WizardInput>
  </>
);

SchoolName.propTypes = {
  setValue: PropTypes.func,
  t: PropTypes.func,
  schoolTitle: PropTypes.string,
};

SchoolName.defaultProps = {
  setValue: () => {},
  t: () => {},
  schoolTitle: '',
};

export default SchoolName;
